"use client";

import React from "react";

const JobsAtMncs = () => {
  return (
    <section className="pt-11 pb-14 bg-[linear-gradient(0deg,#fff_0%,#d6ebff_100%)] max-md:pt-6 max-md:pb-0 max-md:px-3 max-md:bg-[#f3f3f3]">
      <>
        <div
          className="main_container grid items-center gap-[18px] relative max-md:flex max-md:flex-col max-md:gap-0 max-md:p-[18px_14px] max-md:rounded-[18px] max-md:bg-white max-md:shadow-[0_8px_24px_rgba(23,38,67,0.05)]"
          style={{
            gridTemplateColumns: "minmax(0, 0.95fr) minmax(380px, 0.9fr)",
          }}
        >
          <img
            src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/arrow_bg.webp?tr=w-84,h-151,q-85"
            alt="Jobs at Big 4 and MNCs"
            className="hidden"
            loading="lazy"
            decoding="async"
          />
          <div className="flex flex-col items-center text-center pl-6 pr-3 max-md:p-0">
            <h2 className="m-0 text-[#333] text-[28px] font-bold leading-[1.2] block max-md:hidden">
              Jobs at MNCs in{" "}
              <span className="text-[#3399ff]">India, U.S. &amp; Globally</span>
            </h2>

            <h2 className="m-0 text-[#333] text-[28px] font-bold leading-[1.2] hidden max-md:block max-md:text-2xl max-md:leading-[1.15]">
             Jobs at MNCs<br/> in{" "}
              <span className="text-[#3399ff]">India, U.S. &amp; Globally</span>
            </h2>

            <p className="max-w-[440px] mt-6 text-[#999] text-sm font-medium leading-[1.35] max-md:mt-3 max-md:leading-[1.3] [&>strong]:text-[#999] [&>strong]:font-bold">
              <strong>70,000+ Miles alumni</strong> are building global careers
              across<br/> MNCs, and top CMA firms.
            </p>

            <div className="grid grid-cols-2 gap-[30px] w-full max-w-[540px] mt-7 max-md:gap-3 max-md:max-w-none max-md:mt-3">
              <div className="relative pt-5 px-[18px] pb-[18px] bg-center bg-no-repeat bg-contain bg-[url('https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/left_box_new.webp')] max-md:min-h-[92px] max-md:pt-[18px] max-md:px-3 max-md:pb-4 max-md:bg-[url('https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/left_box_mob.webp')]">
                <p className="relative z-[1] m-0 text-black text-sm font-normal leading-[1.2] max-md:text-xs [&>strong]:font-bold">
                  Avg Salary in <strong>India</strong>
                </p>
                <p className="relative z-[1] mt-2 text-[#3399ff] text-[26px] font-bold leading-none max-md:mt-2.5 max-md:text-[22px]">
                  ₹12 lakhs+
                </p>
              </div>

              <div className="relative pt-5 px-[18px] pb-[18px] bg-center bg-no-repeat bg-contain bg-[url('https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/right_box_new.webp')] max-md:min-h-[92px] max-md:pt-[18px] max-md:px-3 max-md:pb-4 max-md:bg-[url('https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/right_box_mob.webp')]">
                <p className="relative z-[1] m-0 text-black text-sm font-normal leading-[1.2] max-md:text-xs [&>strong]:font-bold">
                  Avg Salary in <strong>U.S.</strong>
                </p>
                <p className="relative z-[1] mt-2 text-[#3399ff] text-[26px] font-bold leading-none max-md:mt-2.5 max-md:text-[22px]">
                  ₹50 lakhs+
                </p>
              </div>
            </div>
          </div>

          <div className="relative min-h-[360px] flex items-end justify-center max-md:min-h-0 max-md:mt-[18px]">
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/mnc_india_mobile.webp?tr=w-400,h-305,q-85"
              />
              <source
                media="(min-width: 769px)"
                srcSet="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/mnc_india_desktop.webp?tr=w-960,h-734,q-85"
              />
              <img
                src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/mnc_india_desktop.webp?tr=w-960,h-734,q-85"
                alt="Jobs at Big 4 and MNCs"
                className="relative z-[2] w-full max-w-[480px] h-auto object-contain max-md:max-w-[240px]"
                loading="lazy"
                decoding="async"
              />
            </picture>
          </div>
        </div>
      </>
    </section>
  );
};

export default JobsAtMncs;
